import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitolavasacab() {



  const cardData = {
    keyword: " Mumbai to Lavasa Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Lavasa cab services, ensuring a smooth, safe, and scenic journey for families, couples, and weekend travelers. Lavasa is a beautifully planned hill city near Pune known for its European-style architecture, lakeside promenade, and peaceful environment, making it a perfect quick getaway from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Lavasa route covers approximately 180 to 190 km and takes around 4 to 5 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Lavasa travel.",

"topPlaces": [
  {
    "title": "Lavasa Lake Promenade",
    "description": "Lavasa Lake Promenade is the heart of the city, designed along the lakeside with colorful buildings, cafes, and walking paths. It offers a peaceful European-style vibe where visitors can enjoy evening strolls, photography, boating activities, and relaxing views of the calm water surrounded by hills."
  },
  {
    "title": "Dasve Viewpoint",
    "description": "Dasve Viewpoint offers a panoramic view of Lavasa city, the lake, and surrounding Sahyadri hills. It is one of the best spots for sunrise and sunset photography, especially when clouds float over the valley creating a magical scenic atmosphere."
  },
  {
    "title": "Temghar Dam",
    "description": "Temghar Dam is a large water reservoir near Lavasa surrounded by lush green hills. It is a peaceful location ideal for nature lovers, photography, and enjoying monsoon scenery when the dam overflows and the surroundings turn vibrant green."
  },
  {
    "title": "Varasgaon Dam",
    "description": "Varasgaon Dam is another major dam near Lavasa that supplies water to Pune and surrounding regions. It offers stunning views of backwaters, hills, and cloudy skies, making it a great picnic and relaxation spot."
  },
  {
    "title": "Lavasa Nature Trails",
    "description": "Lavasa Nature Trails are well-marked walking and hiking paths that allow visitors to explore the natural beauty of the region. These trails pass through hills, forests, and viewpoints, making them ideal for adventure lovers and fitness walkers."
  },
  {
    "title": "Town Hall Lavasa",
    "description": "Town Hall Lavasa is a central attraction hosting events, exhibitions, and cultural programs. It reflects the planned city's modern architecture and is a hub for social gatherings and tourism activities."
  },
  {
    "title": "Water Sports Zone",
    "description": "Lavasa Water Sports Zone offers activities like jet skiing, kayaking, and boating on the lake. It is a popular attraction for adventure seekers and families looking for fun recreational experiences."
  },
  {
    "title": "Xthrill Adventure Academy (Near Lavasa)",
    "description": "Xthrill Adventure Academy is an adventure park near Lavasa offering activities like ziplining, rock climbing, and obstacle courses. It is perfect for thrill seekers and group outings looking for adrenaline-filled experiences."
  },
  {
    "title": "Tikona Fort (Nearby Attraction)",
    "description": "Tikona Fort is a historic hill fort located near Lavasa, known for trekking and panoramic views of Pavana Lake and surrounding valleys. It is a popular destination for adventure lovers and history enthusiasts."
  },
  {
    "title": "Panshet Dam",
    "description": "Panshet Dam is a scenic water reservoir near Lavasa offering boating, water sports, and picnic spots. Surrounded by hills and greenery, it is a perfect weekend escape for nature lovers."
  }
],







services: [
  {
    name: "Mumbai to Lavasa Cab",
    description: "Mumbai to Lavasa cab service offers a scenic and comfortable journey to Maharashtra’s planned hill city known for its lakeside views and peaceful surroundings. The route includes beautiful ghats, greenery, and winding roads, making the drive enjoyable. Ideal for weekend getaways, couples, families, and corporate outings, this service ensures safe travel with experienced drivers. Multiple vehicle options are available to suit different needs. It guarantees a relaxing and refreshing trip."
  },
  {
    name: "Mumbai to Lavasa Taxi",
    description: "Mumbai to Lavasa taxi provides convenient and private travel with door-to-door pickup and drop. This service is perfect for travelers seeking a comfortable ride to this hill destination. Vehicles are clean and driven by experienced chauffeurs. Suitable for short trips and vacations. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Lavasa Cab Service",
    description: "Mumbai to Lavasa cab service is designed for safe and comfortable travel through scenic hill routes. This service is ideal for family outings, romantic trips, and group travel. Vehicles are maintained for both highway and ghat performance. Professional drivers ensure smooth travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Lavasa Taxi Service",
    description: "Mumbai to Lavasa taxi service offers dependable intercity travel with a focus on comfort and safety. This service is suitable for tourists, families, and corporate travelers. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy planning. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Lavasa",
    description: "Cab from Mumbai to Lavasa provides a personalized travel experience with flexible stops at scenic viewpoints. Travelers can enjoy a private and relaxed journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a memorable road trip experience."
  },
  {
    name: "Taxi from Mumbai to Lavasa",
    description: "Taxi from Mumbai to Lavasa offers a convenient and efficient way to travel to this hill destination. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for weekend trips and short vacations. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Lavasa Cab Booking",
    description: "Mumbai to Lavasa cab booking allows travelers to reserve their ride easily with flexible travel options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Lavasa Taxi Booking Online",
    description: "Mumbai to Lavasa taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Lavasa Cab Price",
    description: "Mumbai to Lavasa cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Lavasa Taxi Fare",
    description: "Mumbai to Lavasa taxi fare is designed to be affordable and competitive for hill travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Lavasa One Way Cab",
    description: "Mumbai to Lavasa one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for quick getaways. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Lavasa Round Trip Taxi",
    description: "Mumbai to Lavasa round trip taxi is ideal for travelers planning a same-day or weekend return trip. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family outings and sightseeing. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Lavasa Innova Cab",
    description: "Mumbai to Lavasa Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group trips. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Lavasa Ertiga Cab",
    description: "Mumbai to Lavasa Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Lavasa Sedan Cab",
    description: "Mumbai to Lavasa sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for hill journeys. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Lavasa SUV Taxi",
    description: "Mumbai to Lavasa SUV taxi provides extra space and better performance on hilly roads. SUVs offer stability and comfort during ghat travel. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Lavasa Cab",
    description: "Cheap Mumbai to Lavasa cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Lavasa Taxi Service",
    description: "Best Mumbai to Lavasa taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Lavasa Cab", "Mumbai to Lavasa Taxi"],
  ["Mumbai to Lavasa Cab Service", "Mumbai to Lavasa Taxi Service"],
  ["Cab from Mumbai to Lavasa", "Taxi from Mumbai to Lavasa"],
  ["Mumbai to Lavasa Cab Booking", "Mumbai to Lavasa Taxi Booking Online"],
  ["Mumbai to Lavasa Cab Price", "Mumbai to Lavasa Taxi Fare"],
  ["Mumbai to Lavasa One Way Cab", "Mumbai to Lavasa Round Trip Taxi"],
  ["Mumbai to Lavasa Innova Cab", "Mumbai to Lavasa Ertiga Cab"],
  ["Mumbai to Lavasa Sedan Cab", "Mumbai to Lavasa SUV Taxi"],
  ["Cheap Mumbai to Lavasa Cab", "Best Mumbai to Lavasa Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Scenic Mumbai to Lavasa Travel",
    WhyChoosedescription: "Royal Route Cabs offers a beautiful and comfortable Mumbai to Lavasa cab service, perfect for weekend getaways, nature trips, and peaceful hill station visits."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are well-trained for hill and ghat routes, ensuring safe driving and smooth navigation through winding roads to Lavasa."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Lavasa cab service operates 24/7, allowing flexible departure anytime as per your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a relaxing travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Lavasa trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Lavasa cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Lavasa cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Lavasa for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Lavasa?", answer: "The distance is approximately 180 to 200 km and takes around 4 to 5 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Lavasa cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak tourist seasons." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Lavasa trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Jadhav",
    feedback: "Our Mumbai to Lavasa trip with Royal Route Cabs was very enjoyable. The scenic drive was made even better with a smooth and comfortable ride throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Shah",
    feedback: "Had a great experience traveling from Mumbai to Lavasa. The cab was neat, the driver was polite, and the journey felt completely safe and relaxing with Royal Route Cabs.",
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lavasa Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-lavasa-cab.jpg", // replace if needed
  "description": "Book Mumbai to Lavasa cab with Royal Route Cabs for a comfortable and scenic hill station journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-lavasa-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Mumbai to Lavasa Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Lavasa cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to lavasa cab, mumbai to lavasa taxi, mumbai to lavasa cab service, mumbai to lavasa taxi service, cab from mumbai to lavasa, taxi from mumbai to lavasa, mumbai to lavasa cab booking, mumbai to lavasa taxi booking online, mumbai to lavasa cab price, mumbai to lavasa taxi fare, mumbai to lavasa one way cab, mumbai to lavasa round trip taxi, mumbai to lavasa innova cab, mumbai to lavasa ertiga cab, mumbai to lavasa sedan cab, mumbai to lavasa suv taxi, cheap mumbai to lavasa cab, best mumbai to lavasa taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolavasacab;